import { IntegrationOutlined, PauseOutline, PlayOutlined, SuspendedOutline } from 'assets/icons';
import { CardWrap } from '../CardWrap';
import * as S from './StatusCounter.styled';

const iconType = {
  play: PlayOutlined,
  pause: PauseOutline,
  suspended: SuspendedOutline,
  integration: IntegrationOutlined,
};

export const StatusCounter = ({ title, icon = 'play', type = 'green', value = 0, numCols = 1 }) => {
  const Icon = iconType[icon];

  return (
    <CardWrap numCols={numCols} type={type}>
      <S.Wrap>
        <S.Title>{title}</S.Title>
        <S.Value>{value}</S.Value>
        {Icon && (
          <S.IconWrap>
            <Icon />
          </S.IconWrap>
        )}
      </S.Wrap>
    </CardWrap>
  );
};
